var _path, _mask, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3717 1.165C13.325 1.1132 13.2679 1.07176 13.2042 1.04335C13.1405 1.01493 13.0715 1.00016 13.0017 1H3.00175C2.93198 1.00016 2.86301 1.01493 2.79929 1.04335C2.73557 1.07176 2.6785 1.1132 2.63175 1.165C2.58499 1.21591 2.54929 1.27597 2.52692 1.34137C2.50454 1.40678 2.49597 1.47611 2.50175 1.545L2.87675 5.5L3.72675 14.525C3.73801 14.6497 3.79562 14.7656 3.8882 14.8498C3.98078 14.9341 4.10158 14.9805 4.22675 14.98H11.7817C11.9069 14.9805 12.0277 14.9341 12.1203 14.8498C12.2129 14.7656 12.2705 14.6497 12.2817 14.525L13.5017 1.545C13.5075 1.47611 13.499 1.40678 13.4766 1.34137C13.4542 1.27597 13.4185 1.21591 13.3717 1.165ZM12.4517 2L12.1167 5.595C11.1225 5.29915 10.1459 4.94691 9.19175 4.54C6.79675 3.54 5.19175 4.115 3.81175 4.75L3.55175 2H12.4517ZM11.3217 14H4.68175L3.90675 5.805C5.35675 5.125 6.62675 4.555 8.81175 5.46C9.84944 5.90965 10.915 6.29211 12.0017 6.605L11.3217 14ZM6.00175 7L6.50175 12.45C6.50865 12.5157 6.50246 12.5822 6.48353 12.6455C6.4646 12.7088 6.43331 12.7677 6.39146 12.8189C6.34962 12.87 6.29805 12.9123 6.23974 12.9434C6.18143 12.9745 6.11753 12.9938 6.05175 13H6.00175C5.87737 13.0006 5.75722 12.9549 5.66476 12.8717C5.57231 12.7884 5.51419 12.6738 5.50175 12.55L5.00175 7.1C4.98922 6.96807 5.02957 6.83656 5.11395 6.73436C5.19833 6.63217 5.31983 6.56766 5.45175 6.555C5.51709 6.54807 5.58315 6.55409 5.64616 6.5727C5.70918 6.59132 5.7679 6.62218 5.81898 6.66351C5.87006 6.70483 5.91249 6.75583 5.94385 6.81356C5.97521 6.8713 5.99489 6.93465 6.00175 7Z",
    fill: "url(#paint0_linear_897_61030)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_897_61030",
    maskUnits: "userSpaceOnUse",
    x: 4.56641,
    y: 6.29532,
    width: 2.83818,
    height: 7.19156,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.56641,
    y: 6.29532,
    width: 2.83818,
    height: 7.19156
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62734 7.03534C4.59369 6.76125 4.7886 6.51178 5.06268 6.47813C5.33676 6.44447 5.58623 6.63938 5.61989 6.91347L6.3035 12.481C6.33715 12.7551 6.14224 13.0046 5.86816 13.0382C5.59407 13.0719 5.3446 12.877 5.31095 12.6029L4.62734 7.03534Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62734 7.03534C4.59369 6.76125 4.7886 6.51178 5.06268 6.47813C5.33676 6.44447 5.58623 6.63938 5.61989 6.91347L6.3035 12.481C6.33715 12.7551 6.14224 13.0046 5.86816 13.0382C5.59407 13.0719 5.3446 12.877 5.31095 12.6029L4.62734 7.03534Z",
    fill: "url(#paint1_linear_897_61030)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56641 6.53906L5.55895 6.41719L4.56641 6.53906M4.56641 6.53906M6.36443 12.9773L5.37188 13.0992L6.36443 12.9773M6.36443 12.9773M5.37188 13.0992L4.56641 6.53906L5.37188 13.0992M5.06268 6.47813C5.88493 6.37717 6.63334 6.96189 6.7343 7.78414L7.17417 11.3666C7.27513 12.1888 6.69041 12.9373 5.86816 13.0382L5.86816 13.0382C5.73654 13.0544 5.60389 13.0176 5.49939 12.936C5.3949 12.8543 5.32711 12.7345 5.31095 12.6029L4.62734 7.03534L4.56641 6.53906L4.62734 7.03534C4.61118 6.90372 4.64797 6.77107 4.72961 6.66657C4.81125 6.56207 4.93106 6.49429 5.06268 6.47813L5.06268 6.47813Z",
    fill: "#E6ECEA",
    mask: "url(#path-2-outside-1_897_61030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_897_61030",
    x1: 2.5,
    y1: 7.99,
    x2: 13.5035,
    y2: 7.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_897_61030",
    x1: 4.96915,
    y1: 9.81911,
    x2: 5.96169,
    y2: 9.69724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlas);
export default __webpack_public_path__ + "static/media/glas.d5cc14f9fca01b27716af2d4f0e36c0c.svg";
export { ForwardRef as ReactComponent };